<template>
  <div>
    <v-container  fluid class="px-15" style="max-width: 1404px !important;">
      <!-- Spinner de carga -->
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Contenido -->
      <template v-if="!isLoading">
        <!-- Detalle de factura -->
        <div style="position: absolute;">
          <v-btn @click="$emit('back')" text class="pl-0">
            <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
            <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
          </v-btn>
        </div>

        <!-- Titulo -->
        <v-row class="mt-6" justify="center" style="align-items: center;">
          <v-col>
            <h1 class="mb-3" style="font-family: 'montserrat-bold'; color: #193D6E; font-size: 32px; text-wrap: nowrap;">{{ "Detalle de factura" }}</h1>
          </v-col>
          <v-col class="d-flex" style="flex-direction: column; align-items: flex-end;">
            <v-btn
              color="#0075B8"
              elevation="8"
              class="my-2 px-8"
              style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none; max-width: 200px;"
              outlined
              :disabled="invoice.sStatusId != '8e99628b-317c-4569-b149-9dc0105503a5'"
              @click="editInvoice()"
            >
              {{ "Editar factura" }}
            </v-btn>
          </v-col>
        </v-row>

        <!-- Cards -->
        <v-row class="mt-2" justify="center" style="align-items: flex-end;">
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Proveedor:</p>
                <p class="value">{{ invoice.clientsRecipient && invoice.clientsRecipient[0] ? invoice.clientsRecipient[0].sName : '-' }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Status:</p>
                <p class="value">
                  <v-chip
                    v-if="invoice.sStatusId == '8e99628b-317c-4569-b149-9dc0105503a5'"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Unassigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="invoice.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="invoice.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                    outlined
                    color="green"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="invoice.sStatusId == '9cb23e7a-ca9b-4530-a617-83a894553b60'"
                    outlined
                    color="#193D6E"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Profit (%):</p>
                <p class="value profit-text">{{ (invoice.percentProfit ? invoice.percentProfit : 0) + "%" }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Profit ($):</p>
                <p class="value profit-text">{{ "$" + formatMoney(invoice.totalDollarProfit ? invoice.totalDollarProfit : 0) + " " + (invoice.profitCurrency || 'MXN') }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Factura:</p>
                <p class="value">{{ invoice.sInvoice }}</p>
              </div>
              <div class="info-block">
                <p class="label">Purchase Order:</p>
                <p class="value">{{ invoice.sId }}</p>
              </div>
              <hr color="#EBEFF6" style="border-radius: 15px;"></hr>
              <div class="info-block my-2">
                <p class="label">Fecha de compra:</p>
                <p class="value">{{ formatDate(invoice.dPurchaseDate) }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Fecha de vencimiento:</p>
                <p class="value">{{ formatDate(invoice.dDueDate) }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Tipo de cambio protegido:</p>
                <p class="value">{{ "$ " + invoice.dRateProtection + " MXN" }}</p>
              </div>
              <div class="info-block">
                <p class="label">Dias de credito:</p>
                <p class="value">{{ invoice.iCreditPeriod + " dias" }}</p>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="info-block mb-0">
                <p class="label">Monto:</p>
                <p class="value amount-text" style="font-size: 30px;">{{ "$ " + formatMoney(invoice.dTotalAmount) + " USD"}}</p>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabla de conversiones -->
        <template v-if="invoice.transacionsAssigned && invoice.transacionsAssigned.length > 0">
          <!-- Texto -->
          <div style="display: flex; justify-content: space-between;" class="mt-9">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: #193D6E;">{{ "Conversiones Aplicadas" }}</div>
            <v-btn
              icon
              :disabled="invoice.sStatusId == '9cb23e7a-ca9b-4530-a617-83a894553b60'"
              @click="openTransactions()"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <!-- Tabla web -->
          <v-data-table hide-default-header :items="invoice.transacionsAssigned" class="mb-4 d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ texts.conversions.id }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.transactionDate }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.typeTransaction }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.avaibleConversion }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
                  <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
                  <th class="header__title center">{{ texts.conversions.currencyProfit }}</th>
                  <th class="header__title center">{{ texts.conversions.dollarProfit }}</th>
                  <th class="header__title right">{{ texts.conversions.actions }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.transaction.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.created_at) }}</td>
                  <td class="table__item">
                    <v-chip v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                        {{ "Forward" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                        {{ "Forex" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                        {{ "Withdrawal" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                        {{ "Collect" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                        {{ "Pay Now" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                        {{ "Window spot" }}
                      </v-chip>
                      <h4 v-else>
                        {{ "-" }}
                      </h4>
                  </td>
                  <td class="table__item">
                    <v-icon v-if="item.transaction.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'" style="color: green;">mdi-check-circle</v-icon>
                    <v-icon v-else style="color: red;">mdi-close-circle</v-icon>
                  </td>
                  <td class="table__item">$ {{ formatMoney(item.transaction.calculatedAmountUSD != null ? item.transaction.calculatedAmountUSD : item.dAmount) }} USD</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.transaction.calculatedAmountMXN != null ? item.transaction.calculatedAmountMXN : item.dAmount) + " MXN" }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.transaction.dExchangeRate) + " MXN" }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ item.transaction.dollarProfit ? "$ " + formatMoney(item.transaction.dollarProfit) + " " + (item.transaction.profitCurrency || 'MXN') : "-" }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ item.transaction.percentProfit ? formatMoney(item.transaction.percentProfit) + "%" : "-" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToConversion(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ texts.conversionsHistory.viewDetail }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- Tabla mobile -->
          <v-data-table class="d-sm-none d-block" hide-default-header :items="invoice.transacionsAssigned">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.id }}</div>
                    <div>{{ item.transaction.iTrackingId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.conversions.transactionDate }}</div>
                    <div>{{ formatDate(item.created_at) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.typeTransaction }}</div>
                    <div>
                      <v-chip v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                        {{ "Forward" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                        {{ "Forex" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                        {{ "Withdrawal" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                        {{ "Collect" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                        {{ "Pay Now" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                        {{ "Window spot" }}
                      </v-chip>
                      <h4 v-else>
                        {{ "-" }}
                      </h4>
                    </div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.avaibleConversion }}</div>
                    <div>
                      <v-icon v-if="item.transaction.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'" style="color: green;">mdi-check-circle</v-icon>
                      <v-icon v-else style="color: red;">mdi-close-circle</v-icon>
                    </div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountUSD }}</div>
                    <div>$ {{ formatMoney(item.transaction.calculatedAmountUSD != null ? item.transaction.calculatedAmountUSD : item.dAmount) }} USD</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountMXN }}</div>
                    <div>{{ "$ " + formatMoney(item.transaction.calculatedAmountMXN != null ? item.transaction.calculatedAmountMXN : item.dAmount) + " MXN" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.exchangeRate }}</div>
                    <div>{{ "$ " + formatMoney(item.transaction.dExchangeRate) + " MXN" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.currencyProfit }}</div>
                    <div style="color: #0075B8;">{{ item.transaction.dollarProfit ? "$ " + formatMoney(item.transaction.dollarProfit) + " " + (item.transaction.profitCurrency || 'MXN') : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.dollarProfit }}</div>
                    <div style="color: #0075B8;">{{ item.transaction.percentProfit ? formatMoney(item.transaction.percentProfit) + "%" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.suppliers.actions }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToConversion(item)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texts.conversionsHistory.viewDetail }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>

        <!-- Tabla de pagos -->
        <template v-if="invoice.payment && invoice.payment[0] && invoice.payment[0].payment">
          <!-- Texto -->
          <div style="display: flex; justify-content: space-between;">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: #193D6E;">{{ "Pagos Realizados" }}</div>
          </div>

          <!-- Tabla web -->
          <v-data-table hide-default-header :items="invoice.payment" class="mb-4 d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ texts.conversions.id }}</th>
                  <th class="header__title center">{{ texts.conversions.paymentDate }}</th>
                  <th class="header__title center">{{ texts.conversions.status }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
                  <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
                  <th class="header__title center">{{ texts.conversions.currencyProfit }}</th>
                  <th class="header__title center">{{ texts.conversions.dollarProfit }}</th>
                  <th class="header__title right">{{ texts.conversions.actions }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.payment.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.payment.created_at) }}</td>
                  <td class="table__item">
                    <v-chip :color="setStatusColor(statusMap[item.payment.sStatusId])" outlined style="text-wrap: nowrap; white-space: normal;">
                      {{ statusMap[item.payment.sStatusId] || 'UNKNOWN_STATUS' }}
                    </v-chip>
                  </td>
                  <td class="table__item">{{ item.totalOrignAmount ? "$ " + formatMoney(item.totalOrignAmount) + " USD" : "-" }}</td>
                  <td class="table__item">{{ item.totalDescAmount ? "$ " + formatMoney(item.totalDescAmount) + " MXN" : "-" }}</td>
                  <td class="table__item">{{ item.totalOrignAmount > 0 ? "$ " + formatMoney(item.totalDescAmount / item.totalOrignAmount) + " MXN" : "-" }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ item.dollarProfit ? "$ " + formatMoney(item.dollarProfit) + " " + (item.profitCurrency || 'MXN') : "-" }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ item.percentProfit ? item.percentProfit + "%" : "-" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToPayment(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ texts.conversionsHistory.viewDetail }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>

          <!-- Tabla mobile -->
          <v-data-table class="d-sm-none d-block" hide-default-header :items="invoice.payment">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.id }}</div>
                    <div>{{ item.payment.iTrackingId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.paymentDate }}</div>
                    <div>{{ formatDate(item.payment.created_at) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.status }}</div>
                    <div>
                      <v-chip :color="setStatusColor(statusMap[item.payment.sStatusId])" outlined style="text-wrap: nowrap; white-space: normal;">
                        {{ statusMap[item.payment.sStatusId] || 'UNKNOWN_STATUS' }}
                      </v-chip>
                    </div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountUSD }}</div>
                    <div>{{ item.totalOrignAmount ? "$ " + formatMoney(item.totalOrignAmount) + " USD" : "-"  }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountMXN }}</div>
                    <div>{{ item.totalDescAmount ? "$ " + formatMoney(item.totalDescAmount) + " MXN" : "-"  }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.exchangeRate }}</div>
                    <div>{{ item.totalOrignAmount > 0 ? "$ " + formatMoney(item.totalDescAmount / item.totalOrignAmount) + " MXN" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.currencyProfit }}</div>
                    <div style="color: #0075B8;">{{ item.dollarProfit ? "$ " + formatMoney(item.dollarProfit) + " " + (item.profitCurrency || 'MXN') : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.dollarProfit }}</div>
                    <div style="color: #0075B8;">{{ item.percentProfit ? item.percentProfit + "%" : "-"  }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.actions }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToPayment(item)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texts.conversionsHistory.viewDetail }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>
      </template>
    </v-container>

    <!-- Dialogos -->
    <template>
      <v-dialog v-model="dialog" persistent>
        <v-card class="px-3 py-3">
          <div style="width: 100%; text-align: end;">
            <v-btn icon @click="dialog = false">
              <v-icon color="#2E404E">mdi-close</v-icon>
            </v-btn>
          </div>

          <v-card elevation="5" class="mb-6 mx-6 mt-2" style="display: flex; justify-content: space-between;">
            <div class="pa-5" style="display: flex; flex-direction: column;">
              <span class="mon-bold">Cantidad aplicada:</span>
              <span class="mon-bold">{{"$ " + formatMoney(invoice?.totalAmount ? invoice?.totalAmount : "") + " MXN"}}</span>
            </div>
            <div class="pa-5" style="display: flex; flex-direction: column;">
              <span class="mon-bold">Disponible:</span>
              <span class="mon-bold">{{"$ " + formatMoney(invoice?.avaibleAmount ? invoice?.avaibleAmount : "") + " MXN"}}</span>
            </div>
          </v-card>

          <v-card elevation="5" class="mb-6 mx-6">
            <v-card-text>
              <v-row class="pt-4" style="flex-direction: column; overflow-x: auto;">
                <h2 class="pa-4" style="color: black;">Conversiones Aplicadas</h2>
                <v-data-table
                  item-key="sInvoiceTransactionId"
                  :headers="headersForex"
                  disable-sort
                  :items="invoice?.transacionsAssigned"
                  :loading="isLoading"
                >
                  <template v-slot:item.sTransactionType="{ item }">
                    <v-chip
                      v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'"
                      class="ma-2"
                      color="red"
                      outlined
                    >
                      {{ "Forward" }}
                    </v-chip>
                    <v-chip
                      v-else-if="
                        item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'
                      "
                      class="ma-2"
                      color="blue"
                      outlined
                    >
                      {{ "Forex" }}
                    </v-chip>
                  </template>
                  <template v-slot:item.sTransactionAvaible="{ item }">
                    <v-icon v-if="item.transaction.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'" style="color: green;">mdi-check-circle</v-icon>
                    <v-icon v-else style="color: red;">mdi-close-circle</v-icon>
                  </template>
                  <template v-slot:item.iTrackingId="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      {{ item.transaction.iTrackingId }}
                    </h4>
                  </template>
                  <template v-slot:item.sSupplier="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      {{ item.transaction.sSupplier ? item.transaction.sSupplier : "N/A" }}
                    </h4>
                  </template>
                  <template v-slot:item.dPercentAssigned="{ item }">
                    <v-progress-linear
                      :value="item.percent"
                      height="15"
                      style="border-radius: 15px"
                    >
                      <h4 class="py-3" style="color: white">{{ Math.ceil(item.percent) }}%</h4>
                    </v-progress-linear>
                  </template>
                  <template v-slot:item.dAmount="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      $ {{ formatMoney(item.dAmount / (item.transaction.dAmount > 0 ? (item.transaction.dDesAmount / item.transaction.dAmount) : item.transaction.dExchangeRate)) }} USD
                    </h4>
                  </template>
                  <template v-slot:item.dDesAmount="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      $ {{ formatMoney(item.dAmount) }} MXN
                    </h4>
                  </template>
                  <template v-slot:item.dExchangeRate="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      $ {{ formatMoney(item.transaction.dExchangeRate) }} MXN
                    </h4>
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      {{ formatDate(item.transaction.created_at) }}
                    </h4>
                  </template>
                  <template v-slot:item.purchaseDate="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif;"> {{ item.transaction.purchaseDate ? item.transaction.purchaseDate : "N/A" }}  </h4>
                  </template>
                  <template v-slot:item.percentProfit="{ item }">
                    <h4
                      v-if="item.transaction.percentProfit"
                      :style="{ color: item.percentProfit < 0 ? 'red' : 'green' }"
                      style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                    >
                      {{ item.transaction.percentProfit ? formatMoney(item.transaction.percentProfit) + "%" : "N/A" }}
                    </h4>
                    <h4 v-else>{{ "N/A" }}</h4>
                  </template>
                  <template v-slot:item.dollarProfit="{ item }">
                    <h4
                      v-if="item.transaction.dollarProfit"
                      :style="{ color: item.dollarProfit < 0 ? 'red' : 'green' }"
                      style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                    >
                      {{
                        item.transaction.dollarProfit ? "$ " + formatMoney(item.transaction.dollarProfit) + " USD" : ""
                      }}
                    </h4>
                    <h4 v-else>{{ "N/A" }}</h4>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div style="display: flex; align-items: center; justify-content: center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="openEditConversion(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="invoice.sStatusId == '9cb23e7a-ca9b-4530-a617-83a894553b60'"
                            icon
                            color="black"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar monto asignado</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="openDialogDeleteConversion(item)"
                            v-bind="attrs"
                            :disabled="invoice.sStatusId == '9cb23e7a-ca9b-4530-a617-83a894553b60'"
                            v-on="on"
                            icon
                            color="red"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar conversion de la factura</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card elevation="5" class="mb-6 mx-6">
            <v-card-text>
              <v-row class="pt-4" style="flex-direction: column; overflow-x: auto;">
                <h2 class="pa-4" style="color: black;">Conversiones Disponibles</h2>
                <v-data-table
                  :headers="headersAvaibleTransaction"
                  disable-sort
                  :items="avaibleTransactions"
                  :loading="loadingConversion"
                >
                  <template v-slot:item.sTransactionType="{ item }">
                    <v-chip
                      v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'"
                      class="ma-2"
                      color="red"
                      outlined
                    >
                      {{ "Forward" }}
                    </v-chip>
                    <v-chip
                      v-else-if="
                        item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'
                      "
                      class="ma-2"
                      color="blue"
                      outlined
                    >
                      {{ "Forex" }}
                    </v-chip>
                  </template>
                  <template v-slot:item.iTrackingId="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      {{ item.iTrackingId }}
                    </h4>
                  </template>
                  <template v-slot:item.sSupplier="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      {{ item.sSupplier ? item.sSupplier : "N/A" }}
                    </h4>
                  </template>
                  <template v-slot:item.dPercentAssigned="{ item }">
                    <v-progress-linear
                      :value="item.percent"
                      height="15"
                      style="border-radius: 15px"
                    >
                      <h4 class="py-3" style="color: white">{{ Math.ceil(item.percent) }}%</h4>
                    </v-progress-linear>
                  </template>
                  <template v-slot:item.dAmount="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      $ {{ formatMoney(item.dAmount) }} USD
                    </h4>
                  </template>
                  <template v-slot:item.dDesAmount="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      $ {{ formatMoney(item.dDesAmount) }} MXN
                    </h4>
                  </template>
                  <template v-slot:item.dExchangeRate="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      $ {{ formatMoney(item.dExchangeRate) }} MXN
                    </h4>
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                      {{ formatDate(item.created_at) }}
                    </h4>
                  </template>
                  <template v-slot:item.purchaseDate="{ item }">
                    <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif;"> {{ item.purchaseDate ? item.purchaseDate : "N/A" }}  </h4>
                  </template>
                  <template v-slot:item.percentProfit="{ item }">
                    <h4
                      v-if="item.percentProfit != 0"
                      :style="{ color: item.percentProfit < 0 ? 'red' : 'green' }"
                      style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                    >
                      {{ item.percentProfit ? formatMoney(item.percentProfit) + "%" : "N/A" }}
                    </h4>
                    <h4 v-else>{{ "N/A" }}</h4>
                  </template>
                  <template v-slot:item.dollarProfit="{ item }">
                    <h4
                      v-if="item.dollarProfit != 0"
                      :style="{ color: item.dollarProfit < 0 ? 'red' : 'green' }"
                      style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                    >
                      {{
                        item.dollarProfit ? "$ " + formatMoney(item.dollarProfit) + " USD" : ""
                      }}
                    </h4>
                    <h4 v-else>{{ "N/A" }}</h4>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div style="display: flex; align-items: center; justify-content: center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="openAddConversion(item)"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            :disabled="invoice?.avaibleAmount == 0"
                            color="black"
                          >
                            <v-icon left>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar conversion</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditConversion" persistent width="fit-content">
        <v-card v-if="!loading">
          <v-card-title style="display: flex; justify-content: center">
            <span class="text-h4" style="color: black;">{{ "Editar conversion" }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="formEdit"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-row style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Total de factura: </h2>
                  </v-col>
                  <v-col cols="12" md="6" style="text-align: end;">
                    <span class="mon-bold">{{"$ " + formatMoney(invoice?.dTotalAmount) + " MXN"}}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Por aplicar: </h2>
                  </v-col>
                  <v-col cols="12" md="6" style="text-align: end;">
                    <span class="mon-bold">{{"$ " + formatMoney(parseFloat(invoice?.dTotalAmount) - (parseFloat(invoice?.totalAmount) - parseFloat(prevAmountSelected) + parseFloat(conversionSelected?.dAmount ? conversionSelected?.dAmount : 0))) + " MXN"}}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Disponible de conversion: </h2>
                  </v-col>
                  <v-col cols="12" md="6" style="text-align: end;">
                    <span class="mon-bold">{{"$ " + formatMoney(parseFloat(conversionSelected.dTotalAmount) - parseFloat(conversionSelected?.dAmount ? conversionSelected?.dAmount : 0)) + " MXN"}}</span>
                  </v-col>
                </v-row>
                <v-row class="mt-0" style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Monto a aplicar: </h2>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :label="texts.invoices.invoice + '*'"
                      required
                      outlined
                      type="number"
                      hide-details
                      v-model="conversionSelected.dAmount"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*{{ texts.invoices.requiredField }}</small>
          </v-card-text>
          <v-card-actions class="pb-3" style="display: flex; width: 100%; justify-content: space-around;">
            <div style="width: 45%;">
              <v-btn color="black" block text outlined :disabled="loading" @click="dialogEditConversion = false"> {{ texts.modalForm.cancel }} </v-btn>
            </div>
            <div style="width: 45%;">
              <v-btn class="button-save"
                style="width: 200px; color: #FFF; background-color: #193D6E;"
                elevation="0"
                block
                :disabled="loading || parseFloat(invoice?.dTotalAmount) - (parseFloat(invoice?.totalAmount) - parseFloat(prevAmountSelected) + parseFloat(conversionSelected?.dAmount ? conversionSelected?.dAmount : 0)) < 0 || parseFloat(conversionSelected.dTotalAmount) - parseFloat(conversionSelected?.dAmount ? conversionSelected?.dAmount : 0) < 0"
                @click="updateConversion()">
                {{ texts.modalForm.save }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
        <v-skeleton-loader
          v-else
          width="700px"
          type="image"
        ></v-skeleton-loader>
      </v-dialog>
      <v-dialog v-model="dialogAddConversion" persistent width="fit-content">
        <v-card v-if="!loading">
          <v-card-title style="display: flex; justify-content: center">
            <span class="text-h4" style="color: black;">{{ "Agregar conversion" }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="formEdit"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-row style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Total de factura: </h2>
                  </v-col>
                  <v-col cols="12" md="6" style="text-align: end;">
                    <span class="mon-bold">{{"$ " + formatMoney(invoice?.dTotalAmount) + " MXN"}}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Por aplicar: </h2>
                  </v-col>
                  <v-col cols="12" md="6" style="text-align: end;">
                    <span class="mon-bold">{{"$ " + formatMoney(invoice?.avaibleAmount - conversionSelected?.dAmount) + " MXN"}}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Disponible de conversion: </h2>
                  </v-col>
                  <v-col cols="12" md="6" style="text-align: end;">
                    <span class="mon-bold">{{"$ " + formatMoney(conversionSelected.dTotalAmount - conversionSelected?.dAmount) + " MXN"}}</span>
                  </v-col>
                </v-row>
                <v-row class="mt-0" style="display: flex; align-items: center;">
                  <v-col cols="12" md="6">
                    <h2 class="mon-bold" style="color: black;">Monto a aplicar: </h2>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :label="texts.invoices.invoice + '*'"
                      required
                      type="number"
                      outlined
                      hide-details
                      v-model="conversionSelected.dAmount"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*{{ texts.invoices.requiredField }}</small>
          </v-card-text>
          <v-card-actions class="pb-3" style="display: flex; width: 100%; justify-content: space-around;">
            <div style="width: 45%;">
              <v-btn color="black" block text outlined :disabled="loading" @click="dialogAddConversion = false"> {{ texts.modalForm.cancel }} </v-btn>
            </div>
            <div style="width: 45%;">
              <v-btn class="button-save"
                style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                elevation="0"
                block
                :disabled="loading || parseFloat(invoice?.avaibleAmount - conversionSelected?.dAmount).toFixed(2) < 0 || parseFloat(conversionSelected.dTotalAmount - conversionSelected?.dAmount).toFixed(2) < 0"
                @click="addConversion()">
                {{ texts.modalForm.save }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
        <v-skeleton-loader
          v-else
          width="700px"
          type="image"
        ></v-skeleton-loader>
      </v-dialog>
      <v-dialog v-model="dialogDeleteConversion" persistent width="fit-content">
        <v-card>
          <v-card-title class="text-h5 mb-4">
            {{ "¿Estás seguro de que deseas eliminar la asignacion de esta conversion?" }}
          </v-card-title>
          <v-card-text v-if="!loading" class="my-6"
            >{{ "Una vez que eliminas la conversion se ira a saldo disponible MXN." }}</v-card-text
          >
          <div v-else style="display: flex; justify-content: center">
            <v-progress-circular indeterminate color="amber"></v-progress-circular>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text :disabled="loading" @click="dialogDeleteConversion = false"> {{ texts.modalForm.cancel }} </v-btn>
            <v-btn color="#193D6E" class="white--text" :disabled="loading" @click="deleteConversion()">
              {{ texts.modalForm.delete }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSendPayOfInvoice" v-if="dialogSendPayOfInvoice" persistent width="fit-content" class="pa-8">
        <v-card>
          <v-stepper v-model="step" alt-labels elevation="0">
            <v-stepper-header
              color="#193D6E"
              class="mt-5 mr-15 ml-15"
              elevation="0"
              style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
            >
              <v-stepper-step :complete="step > 1" step="1" color="#193D6E"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2" color="#193D6E"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3" color="#193D6E"></v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
            <!-- Paso 1: Monto de pago -->
              <v-stepper-content step="1" class="pt-0">
                <v-container class="mt-1">
                    <v-card-title style="display: flex; justify-content: center">
                      <span class="text-h4" style="color: black;">{{ "Selecciona monto" }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-form
                          ref="formEdit"
                          style="width: 100%"
                          lazy-validation
                          v-on:submit.prevent
                        >
                          <v-row style="display: flex; align-items: center;">
                            <v-col cols="12" md="6">
                              <h2 class="mon-bold" style="color: black;">Total de factura: </h2>
                            </v-col>
                            <v-col cols="12" md="6" style="text-align: end;">
                              <span class="mon-bold">{{"$ " + formatMoney(invoice?.dTotalAmount - dAmountToPay) + " MXN"}}</span>
                            </v-col>
                          </v-row>

                          <v-row style="display: flex; align-items: center;">
                            <v-col cols="12" md="6">
                              <h2 class="mon-bold" style="color: black;">Disponible para pagar: </h2>
                            </v-col>
                            <v-col cols="12" md="6" style="text-align: end;">
                              <span class="mon-bold">{{"$ " + formatMoney(invoice?.avaibleToPayAmount - dAmountToPay) + " MXN"}}</span>
                            </v-col>
                          </v-row>
                          <v-row class="mt-0" style="display: flex; align-items: center;">
                            <v-col cols="12" md="6">
                              <h2 class="mon-bold" style="color: black;">Monto a aplicar: </h2>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                :label="texts.invoices.invoice + '*'"
                                required
                                hide-details
                                type="number"
                                outlined
                                v-model="dAmountToPay"
                                :rules="[validateAmount]"
                                :disabled="loading"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                      <small>*{{ texts.invoices.requiredField }}</small>
                    </v-card-text>
                  <div v-if="!loading" style="display: flex; justify-content: end; margin-top: 20px">
                    <v-btn
                      elevation="0"
                      class="button-cancel mon-regular"
                      @click="cancelPay()"
                      :disabled="loading"
                    >
                      {{ "Cancelar" }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="button-save"
                      style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                      elevation="0"
                      :disabled="parseFloat(invoice?.dTotalAmount) != dAmountToPay || loading || invoice?.avaibleToPayAmount - dAmountToPay < 0"
                      @click="step = 2"
                      >Continuar
                    </v-btn>
                  </div>
                </v-container>
              </v-stepper-content>
              <!-- Paso 2: Detalle de pago -->
              <v-stepper-content step="2" class="pt-0">
                <v-container class="mt-1">
                  <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                    <span class="title font-weight-bold text-textblack"> Detalle de pago </span>
                  </v-card-title>
                  <v-card-text class="py-6 pb-0" v-if="!loading">
                    <div
                      class="mb-8"
                      style="
                        display: flex;
                        justify-content: space-around;
                        background-color: #e2e8f0;
                        flex-direction: column;
                        width: 600px;
                      "
                    >
                      <div
                        class="pt-6 pb-4 px-10"
                        style="display: flex; justify-content: space-between"
                      >
                        <div class="" style="color: black; font-size: 16px">
                          Nombre del cliente:
                        </div>
                        <div v-if="invoice.clientsRecipient" class="" style="color: black; font-size: 22px; font-weight: bold">
                          {{ invoice?.clientsRecipient[0]?.sName }}
                        </div>
                      </div>
                      <div
                        class="py-4 px-10"
                        style="display: flex; justify-content: space-between"
                      >
                        <div class="" style="color: black; font-size: 16px">Numero CLABE:</div>
                        <div v-if="invoice.clientsRecipient" class="" style="color: black; font-size: 22px; font-weight: bold">
                          {{ "***********" + invoice?.clientsRecipient[0].sAccountNumber.slice(-4) }}
                        </div>
                      </div>
                      <div
                        class="py-4 px-10"
                        style="display: flex; justify-content: space-between"
                      >
                        <div class="" style="color: black; font-size: 16px">
                          El destinatario recibirá:
                        </div>
                        <div class="" style="color: black; font-size: 22px; font-weight: bold">
                          $ {{ formatMoney(dAmountToPay) }} MXN
                        </div>
                      </div>
                      <div
                        class="py-4 pb-6 px-10"
                        style="display: flex; justify-content: space-between"
                      >
                        <div class="" style="color: black; font-size: 16px">
                          Fecha de envío:
                        </div>
                        <div class="" style="color: black; font-size: 22px; font-weight: bold">
                          {{ formatDate(today) }}
                        </div>
                      </div>
                      <div
                        class="mt-0 pb-6 px-10"
                        style="display: flex; justify-content: space-between"
                      >
                        <v-textarea
                          name="input-7-1"
                          label="Concepto de pago"
                          v-model="comment"
                          no-resize
                        ></v-textarea>
                      </div>
                    </div>
                  </v-card-text>
                  <div v-else style="display: flex; justify-content: center">
                    <v-progress-circular indeterminate color="amber"></v-progress-circular>
                  </div>
                  <div v-if="!loading" style="display: flex; justify-content: end; margin-top: 20px">
                    <v-btn
                      elevation="0"
                      class="button-cancel mon-regular"
                      @click="step = 1"
                      :disabled="loading"
                    >
                      {{ "Regresar" }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="button-save"
                      style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                      elevation="0"
                      :disabled="!comment || loading"
                      @click="sendVerification(3)"
                      >Continuar
                    </v-btn>
                  </div>
                </v-container>
              </v-stepper-content>

              <!-- Paso 3: Verificacion OTP -->
              <v-stepper-content step="3" class="pt-0">
                <v-container class="mt-1">
                  <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center;">
                    <span class="title font-weight-bold text-textblack">{{ texts.twoFactor.twoFactor }}</span>
                  </v-card-title>
                  <v-card-text class="py-6 pb-0">
                    <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
                      <div>
                        <v-otp-input v-model="otp" length="6" type="number"></v-otp-input>
                        <p style="font-size: 14px; font-weight: 500;">{{ texts.twoFactor.enterCode }}</p>
                      </div>
                    </div>
                  </v-card-text>
                  <div style="display: flex; justify-content: end; margin-top: 20px;">
                    <v-btn elevation="0" class="button-cancel mon-regular" @click="step = 2" :disabled="loading">{{ texts.modalForm.cancel }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="button-save"
                      style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                      elevation="0"
                      :disabled="otp.length < 6 || loading"
                      color="#193D6E"
                      @click="sendPayment()">
                      {{ texts.modalForm.confirmPay }}
                    </v-btn>
                  </div>
                </v-container>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditInvoice" persistent max-width="600px">
        <v-card>
          <v-card-title style="display: flex; justify-content: center">
            <span class="text-h5">{{ texts.invoices.editInvoice }}</span>
          </v-card-title>
          <v-card-subtitle class="pb-0 mt-3">
            <span style="font-size: 15px"
              >{{ texts.invoices.addInvoiceDetail }}</span>
          </v-card-subtitle>
          <v-card-text>
            <v-container>
              <v-row>
                <v-form
                  ref="formEdit"
                  style="width: 100%"
                  lazy-validation
                  v-on:submit.prevent
                >
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.invoice + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        v-model="forms.detail.sInvoice"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.sId"
                        v-model="forms.detail.sId"
                        style="border-radius: 10px"
                        outlined
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-autocomplete
                        :label="texts.invoices.supplier + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        :items="suppliers"
                        item-value="sClientRecipientId"
                        item-text="sName"
                        v-model="forms.detail.sClientRecipientId"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.purchaseDate + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        type="date"
                        v-model="forms.detail.dPurchaseDate"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.totalAmountMXN + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        type="number"
                        v-model="forms.detail.dTotalAmount"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.creditTime + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        type="number"
                        v-model="forms.detail.iCreditPeriod"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.exchangeRateProtected + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        type="number"
                        v-model="forms.detail.dRateProtection"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-row>
            </v-container>
            <small>*{{ texts.invoices.requiredField }}</small>
          </v-card-text>
          <v-card-actions class="pb-4 mt-0" style="justify-content: space-evenly;">
            <v-btn
              color="#0075B8"
              elevation="8"
              class="mr-2 px-10"
              style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
              outlined
              :disabled="loading"
              @click="cancel()"
            >
              {{ texts.modalForm.cancel }}
            </v-btn>
            <v-btn
              color="#193D6E"
              elevation="8"
              class="white--text px-10"
              style="border-radius: 36px; border: 2px solid #102848 !important; font-family: 'montserrat-semibold'; text-transform: none;"
              :disabled="loading"
              :loading="loading"
              @click="updateInvoice()"
            >
              {{ texts.modalForm.save }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "InvoiceMXDetail",
  props: {
    sInvoiceMxId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modal: false,
      dialogDeleteConversion: false,
      dialogAddConversion: false,
      dialogSendPayOfInvoice: false,
      comment: null,
      otp: "",
      dialogEditInvoice: false,
      conversion: {},
      step: 0,
      prevAmountSelected: 0,
      dAmountToPay: 0,
      texts: "",
      dialog: false,
      dialogEditConversion: false,
      isLoading: false,
      invoice: [],
      today: null,
      loading: false,
      statusMap: {
        '2659f31a-8564-46d9-996c-f13e6816549e': 'COMPLETED',
        '5d2b27cd-a066-4631-9f5e-cd7a0b490465': 'PROCESSING',
        'd06ff8a1-746e-4473-bbff-a7a9725b5c97': 'WAITING_FOR_DEPOSIT',
        '948954b2-d503-40b7-ab4e-3d2bad0b2d8b': 'PENDING_TO_PROCESS_SCHEDULED_PAYMENT',
        'f1f776ab-2eb7-438d-9de7-13e9d91d07b9': 'REJECTED',
        '66a50b51-0f67-4891-a782-f9328a783b9d': 'PENDING_TO_PROCESS',
        'f74af04d-18cb-4848-8f5d-1d93e0a60009': 'VALIDATION_AMOUNT',
        '29cb8444-10a8-44e4-a95b-8a474729e96a': 'DEPOSITED',
      },
      conversionSelected: {},
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      forms: {
        detail: {
          sInvoiceMXId: "",
          dPurchaseDate: "",
          sClientRecipientId: "",
          sInvoice: "",
          dTotalAmount: "",
          dRateProtection: "",
          iCreditPeriod: "",
        },
      },
      suppliers: [],
      loadingConversion: false,
      headersForex: [
        { text: "Id", value: "iTrackingId", align: "center", sortable: false},
        { text: "Fecha de creacion", value: "created_at", align: "center"},
        { text: "Tipo de transaccion", value: "sTransactionType", align: "center"},
        { text: "Conversion disponible", value: "sTransactionAvaible", align: "center"},
        { text: "Monto total USD", value: "dAmount", align: "center"},
        { text: "Monto total MXN", value: "dDesAmount", align: "center"},
        { text: "Tasa de cambio", value: "dExchangeRate", align: "center"},
        { text: "Beneficio de moneda (%)", value: "percentProfit", align: "center", sortable: false},
        { text: "Beneficio de moneda", value: "dollarProfit", align: "center", sortable: false},
        { text: "Acciones", value: "actions", align: "center", sortable: false },
      ],
      headersAvaibleTransaction: [
        { text: "Id", value: "iTrackingId", align: "center", sortable: false},
        { text: "Fecha de creacion", value: "created_at", align: "center"},
        { text: "Tipo de transaccion", value: "sTransactionType", align: "center"},
        { text: "Monto total USD", value: "dAmount", align: "center"},
        { text: "Monto total MXN", value: "dDesAmount", align: "center"},
        { text: "Tasa de cambio", value: "dExchangeRate", align: "center"},
        { text: "Beneficio de moneda (%)", value: "percentProfit", align: "center", sortable: false},
        { text: "Beneficio de moneda", value: "dollarProfit", align: "center", sortable: false},
        { text: "Acciones", value: "actions", align: "center", sortable: false },
      ],
      avaibleTransactions: [],
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    setStatusColor: function (status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
       else {
        return "gray";
      }
    },
    validateAmount() {
      if (parseFloat(this.dAmountToPay) <= parseFloat(this.invoice?.avaibleToPayAmount)) {
        return true;
      }
      return "This field is required";
    },
    cancelPay() {
      this.dialogSendPayOfInvoice = false;
      this.dAmountToPay = 0;
    },
    goToConversion(item) {
      this.$router.push("/conversions/" + item.sTransactionId);
    },
    goToPayment(item) {
      this.$router.push("/payments/" + item.sPaymentId);
    },
    openDialogDeleteConversion(item) {
      this.dialogDeleteConversion = true;
      this.conversionSelected = item;
    },
    openAddConversion(conversion) {
      this.dialogAddConversion = true;
      this.loading = true;

      let payload = {
        sTransactionId: conversion.sTransactionId
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/transactions/avaibleTransaction`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.conversionSelected = { ...conversion };
          this.conversionSelected.dAmount = 0;
          this.conversionSelected.dTotalAmount = this.conversionSelected.dDesAmount;
          this.loading = false;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openEditConversion(conversion) {
      this.dialogEditConversion = true;
      this.loading = true;

      let payload = {
        sTransactionId: conversion.sTransactionId,
        sInvoiceMXId: conversion.invoiceMX ? conversion.invoiceMX.sInvoiceMXId : null
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/transactions/avaibleTransaction`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.conversionSelected = { ...conversion };
          this.prevAmountSelected = this.conversionSelected.dAmount;
          this.conversionSelected.dAmount = this.conversionSelected.dAmount;
          this.conversionSelected.dTotalAmount = response.data.transactions.dDesAmount;
          this.loading = false;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openPayInvoices(item) {
      this.dialogSendPayOfInvoice = true;
      this.step = 1;
    },
    sendVerification(step) {
      this.step = step;
      try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          if(!response.data.success){
            this.mixError(response.data.message, response.status);
          }
        })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
        }
        catch(error){
          this.mixError(error.response.data.message, error.response.status);
        }
    },
    updateConversion(item) {
      this.loading = true;
      this.avaibleTransactions = [];
      this.loadingConversion = true;

      let payload = {
        sInvoiceTransactionId: this.conversionSelected.sInvoiceTransactionId,
        dAmount: parseFloat(this.conversionSelected.dAmount)
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/updateConversion`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.loading = false;
          this.getInvoice(true)
          this.dialogEditConversion = false;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    addConversion(item) {
      this.loading = true;
      this.avaibleTransactions = [];
      this.loadingConversion = true;

      let payload = {
        sTransactionId: this.conversionSelected.sTransactionId,
        sInvoiceId: this.invoice.sInvoiceMXId,
        dAmount: parseFloat(this.conversionSelected.dAmount)
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/addConversion`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.loading = false;
          this.getInvoice(true)
          this.dialogAddConversion = false;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    deleteConversion() {
      this.loading = true;
      this.avaibleTransactions = [];
      this.loadingConversion = true;

      let payload = {
        sInvoiceTransactionId: this.conversionSelected.sInvoiceTransactionId,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/deleteConversion`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.loading = false;
          this.getInvoice(true)
          this.dialogDeleteConversion = false;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getSuppliers() {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/client-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.suppliers = response.data.paymentRecipients;
      });
    },
    updateInvoice() {
      if (this.$refs.formEdit.validate()) {
        this.loading = true;

        let payload = {
          sInvoiceMXId: this.forms.detail.sInvoiceMXId,
          dPurchaseDate: this.forms.detail.dPurchaseDate,
          sClientRecipientId: this.forms.detail.sClientRecipientId,
          sInvoice: this.forms.detail.sInvoice,
          sId: this.forms.detail.sId,
          dTotalAmount: this.forms.detail.dTotalAmount,
          dRateProtection: this.forms.detail.dRateProtection,
          iCreditPeriod: this.forms.detail.iCreditPeriod,
        };

        DB.put(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.loading = false;
            this.dialogEditInvoice = false;
            this.getInvoice();
            this.cancel();
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    openTransactions() {
      this.dialog = true;
      this.avaibleTransactions = [];
      this.loadingConversion = true;

      const payload = {
        avaibleAmount: this.invoice.avaibleAmount,
        dRateProtection: this.invoice.dRateProtection
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/transactions/avaibleTransactions`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
      .then((response) => {
        this.avaibleTransactions = response.data.transactions
        this.loadingConversion = false;
      });
    },
    editInvoice() {
      this.dialogEditInvoice = true;
      this.forms.detail.sInvoiceMXId = this.invoice.sInvoiceMXId;
      this.forms.detail.dPurchaseDate = moment(this.invoice.dPurchaseDate).format("YYYY-MM-DD");
      this.forms.detail.sClientRecipientId = this.invoice.sClientRecipientId;
      this.forms.detail.sInvoice = this.invoice.sInvoice;
      this.forms.detail.sId = this.invoice.sId;
      this.forms.detail.dTotalAmount = this.invoice.dTotalAmount;
      this.forms.detail.dRateProtection = this.invoice.dRateProtection;
      this.forms.detail.iCreditPeriod = this.invoice.iCreditPeriod;
    },
    cancel() {
      this.dialogEditInvoice = false;
      this.dialogDeleteConversion = false;
      this.dialogSendPayOfInvoice = false;
      this.dialog = false;
      this.dialogEditConversion = false;
      this.forms.detail = {
        sInvoiceMXId: "",
        dPurchaseDate: "",
        sClientRecipientId: "",
        sInvoice: "",
        dTotalAmount: "",
        dRateProtection: "",
        iCreditPeriod: "",
      };
    },
    handleResize() {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }
      this.isResponsive = window.innerWidth < 960;
    },
    getInvoice(item) {
      this.isLoading = true;
      this.invoice = [];

      DB.get(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/${this.sInvoiceMxId}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.isLoading = false;
          this.invoice = response.data.invoice;
          if (item) {
            this.openTransactions();
          }
          this.invoice.dTotalAmountAssign = 0;
          this.invoice.dOriginAmount = 0;
          this.invoice.transacionsAssigned = [];

          if (this.invoice.invoice_payments_relationship) {
            this.invoice.invoice_payments_relationship.map((rel) => {
              let rate = rel.transaction.dAmount > 0 ? (rel.transaction.dDesAmount / rel.transaction.dAmount) : rel.transaction.dExchangeRate;
              this.invoice.dOriginAmount += parseFloat(rel.dAmount / rate);
              this.invoice.dTotalAmountAssign += parseFloat(rel.dAmount);
              this.invoice.transacionsAssigned.push(rel)
              return rel;
            })
          }
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.isLoading = false;
          this.mixError(error.response ? error.response.data.message : 'Error', error.response ? error.response.status : 500);
        });
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    async validateOtp() {
      try {
        const payload = {
          sCode: this.otp
        };

        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/authenticator/verify`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        return response.data.success;
      } catch (error) {
        return false;
      }
    },
    async sendPayment() {
      this.loading = true;

      const isValid = await this.validateOtp();
      if (!isValid) {
        this.mixError("Codigo OTP incorrecto", 400);
        this.loading = false;
        return;
      }

      const payload = {
        invoices: [{
          sInvoiceMXId: this.invoice.sInvoiceMXId,
          dAmount: parseFloat(this.dAmountToPay),
        }],
        paymentType: 'full',
        sortDirection: 'asc',
        originCurrency: 'USD',
        destCurrency: 'MXN',
      };

      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/sendPaymentNowFromInvoice`,
        payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
            }
          }
        );
        this.cancel();
        this.getInvoice();
        this.loading = false;
        if (!response.data.success) {
          this.mixError(response.data.message, response.status);
          return;
        }
      } catch (error) {
        this.loading = false;
        this.mixError(error.response.data.message, error.response.status);
      }
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getInvoice();
    this.getSuppliers();
    this.today = moment().add(1, "day").format("YYYY-MM-DD");
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.text-return {
  font-family: "montserrat-medium";
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F6F8FC;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
}

.profit-text {
  color: #0075B8;
}

.amount-text {
  font-size: 22px;
  color: black;
  font-family: "montserrat-bold";
}

.action-btn {
  border-radius: 36px;
  font-family: "montserrat-semibold";
  text-transform: none;
  border: 2px solid #0075BB;
}

.action-btn.primary {
  background-color: #0075B8;
  color: white;
}

.v-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
